/* eslint-disable */
// @ts-nocheck

import { create } from 'zustand'

// src/stores/useCounterStore.ts
import { User } from '@/interfaces/vehicle'

// 1. Define la interfaz para el estado y las acciones de tu store
interface VehicleFormState {
  vehicle_name: string
  vehicle_identification: string
  vehicle_number: string
  vehicle_type: string
  vehicle_max_weight: string
  vehicle_max_height: st
  amount: number
  mode: string
  codeCurrency: string

  // Acciones: Son funciones que no reciben nada y no devuelven nada,
  // o que reciben argumentos y no devuelven nada.

  updateVehicleName: (vehicle_name: string) => void
  updateVehicleIdentification: (vehicle_identification: string) => void
  updateVehicleNumber: (vehicle_number: string) => void
  updateVehicleType: (vehicle_type: string) => void
  updateVehicleMaxWeight: (vehicle_max_weight: string) => void
  updateVehicleMaxHeight: (vehicle_max_height: string) => void
  updateVehicleAmount: (amount: number | null) => void
  updateVehicleMode: (mode: string) => void
  updateVehicleCodeCurrency: (codeCurrency: string) => void
  updateVehicleUsers: (vehicle_users: User) => void
}

// 2. Crea el store, pasando tu interfaz como un argumento genérico a `create`
const useLogisticVehicleForm = create<VehicleFormState>((set, get) => ({
  // Estado inicial
  vehicle_name: '',
  vehicle_identification: '',
  vehicle_number: '',
  vehicle_type: '',
  vehicle_max_weight: '',
  vehicle_max_height: '',
  vehicle_users: {
    id: 0,
    displayName: '',
    email: '',
  },
  amount: null,
  mode: '',
  codeCurrency: '',

  // Acciones (implementación de las funciones definidas en la interfaz)
  updateVehicleName: (vehicle_name: string) => set(() => ({ vehicle_name })),
  updateVehicleIdentification: (vehicle_identification: string) =>
    set(() => ({ vehicle_identification })),
  updateVehicleNumber: (vehicle_number: string) =>
    set(() => ({ vehicle_number })),
  updateVehicleType: (vehicle_type: string) => set(() => ({ vehicle_type })),
  updateVehicleMaxWeight: (vehicle_max_weight: string) =>
    set(() => ({ vehicle_max_weight })),
  updateVehicleMaxHeight: (vehicle_max_height: string) =>
    set(() => ({ vehicle_max_height })),
  updateVehicleAmount: (amount: number) => set(() => ({ amount })),
  updateVehicleMode: (mode: string) => set(() => ({ mode })),
  updateVehicleCodeCurrency: (codeCurrency: string) =>
    set(() => ({ codeCurrency })),
  updateVehicleUsers: (vehicle_users: User) => set(() => ({ vehicle_users })),
}))

export default useLogisticVehicleForm
